// extracted by mini-css-extract-plugin
export default {"overlay":"popup-menu_overlay__2rhmj","popup":"popup-menu_popup__gCt4B","menu-items":"popup-menu_menu-items__8rAh2","item":"popup-menu_item__sGWtC"};